import React from 'react';
import { ContainerError } from '../styles';
import ImageTitle, { Icons } from '../../../components/ImageTitle';

export default function Error() {
  return (
    <ContainerError>
      <ImageTitle
        data-cy='authorizarion-term-error'
        text="Ocorreu um erro ao buscar o termo. Por favor, tente novamente mais tarde."
        icon={Icons.alertOrder}
        primary
      />
    </ContainerError>
  );
};
